var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSpiderWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.78,7.47L8.53,1.22c-0.29-0.29-0.77-0.29-1.06,0L1.22,7.47C1.08,7.61,1,7.8,1,8s0.08,0.39,0.22,0.53 l6.25,6.25C7.62,14.93,7.81,15,8,15c0.19,0,0.38-0.07,0.53-0.22l6.25-6.25C14.92,8.39,15,8.2,15,8S14.92,7.61,14.78,7.47z  M12.94,7.75h-1.59l-3.1-3.1V3.06L12.94,7.75z M7.75,6.75l-1,1h-1.4l2.4-2.4V6.75z M6.75,8.25l1,1v1.4l-2.4-2.4H6.75z M8.25,9.25 l1-1h1.4l-2.4,2.4V9.25z M9.25,7.75l-1-1v-1.4l2.4,2.4H9.25z M7.75,3.06v1.59l-3.1,3.1H3.06L7.75,3.06z M3.06,8.25h1.59l3.1,3.1 v1.59L3.06,8.25z M8.25,12.94v-1.59l3.1-3.1h1.59L8.25,12.94z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpiderWeb);
export default __webpack_public_path__ + "static/media/icon_spider-web.5bc950fad6d717d4ebd4e4eaaed2a2c9.svg";
export { ForwardRef as ReactComponent };